import { render, staticRenderFns } from "./RedirectionsList.vue?vue&type=template&id=0e4b1fab&scoped=true"
import script from "./RedirectionsList.vue?vue&type=script&lang=js"
export * from "./RedirectionsList.vue?vue&type=script&lang=js"
import style0 from "./RedirectionsList.vue?vue&type=style&index=0&id=0e4b1fab&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4b1fab",
  null
  
)

export default component.exports